import './index.scss';

import React from 'react';

import IconButton from "../icon-button";

class NumberInput extends React.Component {

  static defaultProps = {
    amount: 1,
    min: 1,
    max: null,
    onChange: () => {},
    onRemove: () => {}
  };

  constructor(props) {

    super(props);

    this.state = {
      value: 1
    };

    this.input = React.createRef();
  }

  componentDidUpdate(prevProps) {

    if (this.props.amount !== prevProps.amount) {
      this.setState({value: this.props.amount});
    }
  }

  componentDidMount() {

    this.setState({value: this.props.amount});
  }

  increment() {

    let amount = (this.props.max ? Math.min(this.props.max, this.state.value + 1) : this.state.value + 1);
    this.onChange(amount);
  }

  decrement() {
    let amount = null;
    
    if (this.props.min) {
      amount = Math.max(this.props.min, this.state.value - 1);
    }
    else {
      amount = this.state.value - 1;
    }
    
    this.onChange(amount);
  }

  handleChange(e) {
    if (parseInt(e.target.value) <= 0) {
      this.props.onRemove();
    }

    let value = parseInt(e.target.value) || this.props.min;
    let clampMax = (this.props.max ? Math.min(this.props.max, value) : value);
    let clampMin = Math.max(this.props.min, clampMax);

    this.onChange(clampMin);
  }

  handleKeyDown(e) {

    if (e.keyCode === 38) {
      this.increment();
    }

    if (e.keyCode === 40) {
      this.decrement();
    }
  }

  onChange(amount) {

    this.setState(() => { return {value: amount}});
    this.props.onChange(amount);
  }

  getValue() {

    return this.state.value;
  }

  render() {

    return (
      <div className="number-input">

        <div className="number-input__button number-input__decrement-button">
          <IconButton iconType="remove" onClick={e => this.decrement()} />
        </div>

        <input ref={this.input} className="number-input__field" value={this.state.value} type="text"
               onChange={e => this.handleChange(e)}
               onKeyDown={e => this.handleKeyDown(e)}
               onKeyUp={e => this.handleChange(e)}
        />

        <div className="number-input__button number-input__increment-button">
          <IconButton iconType="add" onClick={e => this.increment()} />
        </div>

      </div>
    );
  }
}

export default NumberInput;